import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ToggleSidebar from "./ui/ToggleSidebar";

const EmployeeSidebar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  // Check if user is a manager (assumes user object has is_manager flag from backend)
  const isManager = user?.is_manager || false;

  const menuItems = [
    { key: "dashboard", label: "Dashboard", to: "/employee/dashboard" },
    { key: "tasks", label: "My Tasks", to: "/employee/tasks" },
    ...(isManager ? [{ key: "my-team", label: "My Team", to: "/employee/my-team" }] : []),
    { key: "profile", label: "My Profile", to: "/employee/profile" },
    { key: "attendance", label: "Attendance", to: "/employee/attendance" },
    { key: "leaves", label: "Leaves", to: "/employee/leaves" },
    { key: "salary", label: "Salary", to: "/employee/salary" },
    { key: "payslips", label: "Payslips", to: "/employee/payslips" },
    { key: "holidays", label: "Holiday Calendar", to: "/employee/holidays" },
    { key: "announcements", label: "Announcements", to: "/employee/announcements" },
    { key: "meetings", label: "Meetings", to: "/employee/meetings" },
    { key: "email-settings", label: "Email Settings", to: "/employee/email-settings" },
  ];

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <ToggleSidebar
      title="HRMS"
      subtitle="Employee Portal"
      menuItems={menuItems}
      onLogout={handleLogout}
      isMobileMenuOpen={isMobileMenuOpen}
      setIsMobileMenuOpen={setIsMobileMenuOpen}
    />
  );
};

export default EmployeeSidebar;

